export const screenNames = {
  LoginSignUpComponent: "LoginSignUpComponent",
  OTPComponent: "OTPComponent",
  BasicDetailComponent: "BasicDetailComponent",
  ProfessionalDetailComponent: "ProfessionalDetailComponent",
  FAComponent: "FAComponent"
  // WorkExperienceComponent: "WorkExperienceComponent",
  // LocationComponent: "LocationComponent",
  // SuccessComponent: "SuccessComponent"
};

export const progressStatus = {
  [screenNames.BasicDetailComponent]: 1,
  [screenNames.ProfessionalDetailComponent]: 2,
  [screenNames.FAComponent]: 3
  // [screenNames.WorkExperienceComponent]: 3,
  // [screenNames.LocationComponent]: 4
};

export const componentWithBackButton = {
  OTPComponent: "OTPComponent",
  FAComponent: "FAComponent"
  // WorkExperienceComponent: "WorkExperienceComponent",
  // LocationComponent: "LocationComponent"
};
